<div class="w-full mx-auto p-6 rounded-lg">
    <h2 class="titre3 text-center">{{ 'SCORMS_LIST.PREVIEW_CONFIRMATION_TITLE' | translate }}</h2>
    <mat-dialog-content>
        <p class="mb-4 text-white">{{ 'SCORMS_LIST.PREVIEW_CONFIRMATION_MESSAGE' | translate }}</p>
        <p class="mb-4 text-white">{{ 'SCORMS_LIST.PREVIEW_CONFIRMATION_RESTART_MESSAGE' | translate }}</p>
    </mat-dialog-content>
    <div class="flex justify-end mt-4">
        <button (click)="onCancel()" type="button" class="btn-secondary-novo">
            {{ 'SCORMS_LIST.PREVIEW_CANCEL_BUTTON' | translate }}
        </button>
        <button (click)="onConfirm()" type="button" class="btn-primary-novo">
            {{ 'SCORMS_LIST.PREVIEW_CONFIRM_BUTTON' | translate }}
        </button>
    </div>
</div>